/** A row in the "all upcoming assignments" workload list — jobs that aren't
 * yet scheduled, or services the photographer is assigned on where someone
 * else is the primary on-site shooter. */
export function PhotographerWorkloadItem({ item, serviceNames }) {
  return (
    <div data-testid={`photographer-workload-item-${item.booking_id}`} className="border border-[#282C34] bg-[#121418] p-4 sm:p-5 flex flex-wrap items-center justify-between gap-4">
      <div>
        <h3 className="text-base">{item.address?.street}, {item.address?.city}</h3>
        <p className="text-xs text-[#9A9EA7] mt-1 font-mono">{item.contact?.name} · #{item.job_number}</p>
      </div>
      <div className="text-right">
        <div className="text-xs font-mono text-[#C8B9A6]">{item.scheduled_date ? `${item.scheduled_date} · ${item.scheduled_time}` : "Not yet scheduled"}</div>
        <div className="text-xs text-[#9A9EA7] mt-1">{item.is_primary ? "Whole job" : item.assigned_service_ids.map((sid) => serviceNames[sid] || sid).join(", ") || "Assigned"}</div>
      </div>
    </div>
  );
}
